import { SERVER_API_URL } from '../constants/constants';
import axios from 'axios';

const getPendingSummary = async () => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };

    const url = `${SERVER_API_URL}/admin/analytics/pending-summary`;

    try {
        const result = await axios.get(url, config);
        return result.data;
    } catch (error) {
        console.error('Error fetching pending summary:', error);
        throw error;
    }
};

export { getPendingSummary };
